/**
 * Remove left borders for items that are first in row
 **/
app.add({
    onLoad: function(){
        this.Footer.items = $('#footer .language li');
        window.addEventListener('load', this.Footer);
        window.addEventListener('resize', this.Footer);
    },

    Footer: {
        handleEvent: function(e){
            var line_top = 0;
            for (var i = 0; i < this.items.length; i++){
                var item = this.items[i];
                item.className = item.className.replace(' first-in-line', '');
                var top = Math.round(item.getBoundingClientRect().top);
                if (top > line_top) {
                    line_top = top;
                    item.className += ' first-in-line';
                }
            }
        }
    }
});













// WEBPACK FOOTER //
// ./resources/assets/js/modules/footer.js